import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/render/project/src/src/components/MdxPageLayout/index.jsx";
import ComparisonResultsPageHero from "../../components/ComparisonResultsPageHero";
import ComparisonResultPageTextWithImageSection from "../../components/ComparisonResultPageTextWithImageSection";
import ComparisonResultGrid from "../../components/ComparisonResultGrid";
import ComparisonResultColumnContent from "../../components/ComparisonResultColumnContent";
import ComparisonResultColumnContentBackgroundContainer from "../../components/ComparisonResultColumnContentBackgroundContainer";
import ComparisonResultGettingStartedBlock from "../../components/ComarisonResultPageGetStartedBlock";
import ComparisonPageRecommendations from "../../components/ComparisonPageRecommendations";
import ComparisonResultPageLearnMoreContainer from "../../components/ComparisonResultPageLearnMoreContainer";
import BusinessBankingIllustration from "../../../svg/ComparisonResultPageIllustrations/businessbanking.svg";
import CCUSVG from "../../../svg/ComparisonResultGridLogos/businessbanking/consumercreditunion.svg";
import BankNovoSVG from "../../../svg/ComparisonResultGridLogos/businessbanking/novo.svg";
import ChaseSVG from "../../../svg/ComparisonResultGridLogos/businessbanking/chasebank.svg";
import AxosSVG from "../../../svg/ComparisonResultGridLogos/businessbanking/axosbank.svg";
import CapitalOneSVG from "../../../svg/ComparisonResultGridLogos/businessbanking/capitalone.svg";
export const pageMetaData = {
  pageTitle: "Compare Business Banking Services",
  pageDescription: "Review The Five Best Banking Services",
  pageImagePath: "/businessbankingservices.jpg",
  showNavbar: false,
  pageMetaTags: []
};
export const resultGridConfig = {
  columnConfiguration: {
    columns: [{
      index: 1,
      rows: [{
        index: 1,
        text: "Checking Account Fee"
      }, {
        index: 2,
        text: "Minimum Balance"
      }, {
        index: 3,
        text: "Free Monthly Transactions"
      }, {
        index: 4,
        text: "Free Cash Deposits"
      }, {
        index: 5,
        text: "Credit Cards Available?"
      }, {
        index: 6,
        text: "Loans Available?"
      }],
      expansionRows: [{
        index: 7,
        text: "Transaction Fee"
      }, {
        index: 8,
        text: "Cash Deposit Fee"
      }]
    }, {
      index: 2,
      isComingSoon: false,
      rows: [{
        index: 1,
        isHeadingCell: true,
        displayHeadingCell: true,
        heading: {
          text: "Consumer Credit Union",
          subText: "",
          imageKey: "ccu"
        }
      }, {
        index: 2,
        text: "0",
        isPriceCell: true,
        showSavingText: false,
        showRating: true,
        rating: 4
      }, {
        index: 3,
        text: "$500"
      }, {
        index: 4,
        text: "150"
      }, {
        index: 5,
        text: "$1500 per day"
      }, {
        index: 6,
        text: "yes",
        useIcon: true,
        icon: "tick"
      }, {
        index: 7,
        text: "yes",
        useIcon: true,
        icon: "tick"
      }],
      expansionRows: [{
        index: 8,
        text: "$0.25"
      }, {
        index: 9,
        text: "$1 per $1000"
      }],
      claimButtonConfiguration: {
        targetUrl: "https://consumer-credit-union.4cna.net/c/1323808/548118/9094?u=https%3A%2F%2Fwww.myconsumers.org%2Fbusiness%2Fbusiness-banking%2Faccounts",
        openLinkExternally: true,
        text: "Open Account",
        title: "Click to open an account with Consumer Credit Union",
        subText: "",
        showIcon: false
      }
    }, {
      index: 3,
      isComingSoon: false,
      rows: [{
        index: 1,
        isHeadingCell: true,
        displayHeadingCell: true,
        heading: {
          text: "Bank Novo",
          subText: "",
          imageKey: "bank-novo"
        }
      }, {
        index: 2,
        text: "0",
        isPriceCell: true,
        showSavingText: false,
        showRating: true,
        rating: 3
      }, {
        index: 3,
        text: "$50"
      }, {
        index: 4,
        text: "Unlimited"
      }, {
        index: 5,
        text: "N/A"
      }, {
        index: 6,
        text: "No",
        useIcon: true,
        icon: "cross"
      }, {
        index: 7,
        text: "No",
        useIcon: true,
        icon: "cross"
      }],
      expansionRows: [{
        index: 8,
        text: "$0"
      }, {
        index: 9,
        text: "$0"
      }],
      claimButtonConfiguration: {
        targetUrl: "https://banknovo.qkweww.net/c/1323808/751392/10939",
        openLinkExternally: true,
        text: "Open Account",
        title: "Click to open an account with Bank Novo",
        subText: "",
        showIcon: false
      }
    }, {
      index: 4,
      isComingSoon: false,
      rows: [{
        index: 1,
        isHeadingCell: true,
        displayHeadingCell: true,
        heading: {
          text: "Chase",
          subText: "",
          imageKey: "chase"
        }
      }, {
        index: 2,
        text: "15",
        isPriceCell: true,
        showSavingText: false,
        showRating: true,
        rating: 4
      }, {
        index: 3,
        text: "$1500 (To Waive Account Fees)"
      }, {
        index: 4,
        text: "100"
      }, {
        index: 5,
        text: "$5000"
      }, {
        index: 6,
        text: "Yes",
        useIcon: true,
        icon: "tick"
      }, {
        index: 7,
        text: "Yes",
        useIcon: true,
        icon: "tick"
      }],
      expansionRows: [{
        index: 8,
        text: "$0.40"
      }, {
        index: 9,
        text: "$2.50 per $1000"
      }],
      claimButtonConfiguration: {
        targetUrl: "https://www.chase.com/",
        openLinkExternally: true,
        text: "Open Account",
        title: "Click to open an account with Chase",
        subText: "",
        showIcon: false
      }
    }, {
      index: 5,
      isComingSoon: false,
      rows: [{
        index: 1,
        isHeadingCell: true,
        displayHeadingCell: true,
        heading: {
          text: "Axos",
          subText: "",
          imageKey: "axos"
        }
      }, {
        index: 2,
        text: "0",
        isPriceCell: true,
        showSavingText: false,
        showRating: true,
        rating: 3
      }, {
        index: 3,
        text: "$0"
      }, {
        index: 4,
        text: "200"
      }, {
        index: 5,
        text: "N/A"
      }, {
        index: 6,
        text: "No",
        useIcon: true,
        icon: "cross"
      }, {
        index: 7,
        text: "Yes",
        useIcon: true,
        icon: "tick"
      }],
      expansionRows: [{
        index: 8,
        text: "$0.30"
      }, {
        index: 9,
        text: "N/A"
      }],
      claimButtonConfiguration: {
        targetUrl: "https://www.axosbank.com/",
        openLinkExternally: true,
        text: "Open Account",
        title: "Click to open an account with Axos",
        subText: "",
        showIcon: false
      }
    }, {
      index: 6,
      isComingSoon: false,
      rows: [{
        index: 1,
        isHeadingCell: true,
        displayHeadingCell: true,
        heading: {
          text: "Capital One",
          subText: "",
          imageKey: "capital-one"
        }
      }, {
        index: 2,
        text: "15",
        isPriceCell: true,
        showSavingText: false,
        showRating: true,
        rating: 2
      }, {
        index: 3,
        text: "$2000 (To Waive Account Fees)"
      }, {
        index: 4,
        text: "Unlimited"
      }, {
        index: 5,
        text: "$5000"
      }, {
        index: 6,
        text: "Yes",
        useIcon: true,
        icon: "tick"
      }, {
        index: 7,
        text: "Yes",
        useIcon: true,
        icon: "tick"
      }],
      expansionRows: [{
        index: 8,
        text: "N/A"
      }, {
        index: 9,
        text: "$1 per $1000"
      }],
      claimButtonConfiguration: {
        targetUrl: "https://www.capitalone.com",
        openLinkExternally: false,
        text: "Open Account",
        title: "Click to open an accout with Capital One",
        subText: "",
        showIcon: false
      }
    }]
  }
};
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  pageMetaData,
  resultGridConfig,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">





    <ComparisonResultsPageHero mdxType="ComparisonResultsPageHero">
      <h1>{`Compare business banking services`}</h1>
      <ComparisonResultPageTextWithImageSection images={[<BusinessBankingIllustration imagekey="large-view" className="h-56 ml-auto" mdxType="BusinessBankingIllustration" />, <BusinessBankingIllustration imagekey="mobile-view" className="h-56 w-full" mdxType="BusinessBankingIllustration" />]} mdxType="ComparisonResultPageTextWithImageSection">
        <p>{`Looking for the best bank can be daunting considering the number of financial institutions in Texas and the wide variety of services they offer. To make this task less overwhelming, we compare banks, list their available services, and present the pros and cons of what they provide.`}</p>
      </ComparisonResultPageTextWithImageSection>
    </ComparisonResultsPageHero>
    <ComparisonResultGrid columnConfiguration={resultGridConfig.columnConfiguration} mdxType="ComparisonResultGrid">
  <CCUSVG className="w-full" imagekey="ccu" mdxType="CCUSVG" />
  <BankNovoSVG className="w-full" imagekey="bank-novo" mdxType="BankNovoSVG" />
  <ChaseSVG className="w-full" imagekey="chase" mdxType="ChaseSVG" />
  <AxosSVG className="w-full" imagekey="axos" mdxType="AxosSVG" />
  <CapitalOneSVG className="w-full" imagekey="capital-one" mdxType="CapitalOneSVG" />
    </ComparisonResultGrid>
    <ComparisonResultColumnContent blogContentCategory="banking" mdxType="ComparisonResultColumnContent">
      <ComparisonResultColumnContentBackgroundContainer mdxType="ComparisonResultColumnContentBackgroundContainer">
        <h2>{`How We Ranked and Compared Banks`}</h2>
        <h3>{`Evaluate Bank Ratings`}</h3>
        <p>{`The Federal Deposit Insurance Corporation (FDIC) and other financial institution rating companies give banks a letter or number grade based on their financial soundness. These rankings are calculated based on the bank's capital and assets, financial management, overall earnings, liquidity, and performance based on market risk. For this comparison, we used the Bauer Financial Institute's star rating system and selected only banks that received a five- or four-star rating.`}</p>
        <h3>{`Compare Banks by Services Offered`}</h3>
        <p>{`For each financial institution, we looked at bank size, accessibility to branch locations, account fees, interest rates, and available services. Some institutions, like USAA, don't have many branches and aren't even available to non-military; however, if you are eligible and don't mind using an excellent mobile app, this is a solid and trustworthy institution with good customer service and plenty of other useful services.`}</p>
        <p>{`If you want to stick with a local bank where you can be sure of reaching someone in person, Frost Bank or Prosperity Bank are excellent choices. If you do a lot of traveling and want a bank you can use no matter where you go, WellsFargo is your best bet.`}</p>
      </ComparisonResultColumnContentBackgroundContainer>
      <ComparisonResultGettingStartedBlock mdxType="ComparisonResultGettingStartedBlock" />
      <ComparisonPageRecommendations requestingProductCategory="business banking" mdxType="ComparisonPageRecommendations" />
      <ComparisonResultPageLearnMoreContainer mdxType="ComparisonResultPageLearnMoreContainer">
        <h3>{`Learn More`}</h3>
        <p>{`Just like personal banking accounts, there are so many options available. We continue to review the available accounts so that when it is time for you to open a new account you can be certain that `}<a parentName="p" {...{
            "href": "/"
          }}>{`The Comparison Company`}</a>{` has found the best options for you.`}</p>
      </ComparisonResultPageLearnMoreContainer>
    </ComparisonResultColumnContent>



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      